import axios from "axios";
import { StaticVariables } from "../StaticVariables";

export type AffiliatePlatform = "Amazon" | "LTK" | "ShopMy";

const PLATFORM_MAP: Record<string, AffiliatePlatform> = {
  amazon: "Amazon",
  Amazon: "Amazon",
  ltk: "LTK",
  LTK: "LTK",
  shopmy: "ShopMy",
  ShopMy: "ShopMy",
};

/**
 * Local cron_job for affiliate storefront testing.
 * Flip USE_LOCAL_CRON to true to hit localhost:3001 instead of API_BASE.
 */
const USE_LOCAL_CRON = false;
const LOCAL_CRON_BASE = "http://localhost:3001";

function affiliateApiBase(): string {
  return USE_LOCAL_CRON ? LOCAL_CRON_BASE : StaticVariables().API_BASE;
}

/**
 * Fire-and-forget: scrape an affiliate storefront and store products via
 * cron_job POST /api/affiliate/scrape-storefront (async 202).
 * Does not throw — connection UX must not block on scrape completion.
 */
export function fireAffiliateStorefrontScrape(params: {
  username: string;
  userId?: string | null;
  platform: string;
  storefrontUrl: string;
}): void {
  const username = String(params.username || "").trim();
  const storefrontUrl = String(params.storefrontUrl || "").trim();
  const platform = PLATFORM_MAP[params.platform] || null;

  if (!username || !storefrontUrl || !platform) {
    console.warn(
      "[AffiliateStorefrontScrape] skipped — missing username, url, or platform",
      { username, storefrontUrl, platform: params.platform },
    );
    return;
  }

  const API_BASE = affiliateApiBase();
  const url = `${API_BASE}/api/affiliate/scrape-storefront`;

  console.log(
    `[AffiliateStorefrontScrape] firing ${platform} → ${url}`,
    { username, storefrontUrl },
  );

  void axios
    .post(
      url,
      {
        username,
        user_id: params.userId || undefined,
        platform,
        storefrontUrl,
      },
      { timeout: 15000 },
    )
    .then((res) => {
      console.log(
        `[AffiliateStorefrontScrape] started ${platform} for ${username}:`,
        res.status,
        res.data?.message,
      );
    })
    .catch((err) => {
      console.error(
        `[AffiliateStorefrontScrape] failed to start ${platform} for ${username}:`,
        err?.response?.data || err?.message || err,
      );
    });
}
